import React, {Component, useState} from "react";
import axios from "axios";
import Modal from "react-modal";
import Dashboard from "./Dashboard";
import MangeDashboard from "./MangeDashboard";
import {useNavigate} from "react-router-dom";
import Toast from "./Tost";
import './Ehraz.css'
import SelfiExample from "./SelfiExample";
import {useMediaQuery} from "beautiful-react-hooks";
import { toast } from "react-toastify";
import Resizer from "react-image-file-resizer";
import { formatDate } from "@mobiscroll/react";
import WebcamRecorder from "./WebcamRecorder ";

function TopAuthentication(){
    var IsDigit = new RegExp(/^[0-9]/);
    var IsSheba = new RegExp(/^IR[0-9]/)


    const BASEURL = 'https://api.sinatether.com/Auth/Ehraz/';
    const navigate = useNavigate();


    const [message,setmessage] = useState('')
    const [type,settype] = useState('')

    const [meli,setmeli] = useState('')
    const [profile,setprofile] = useState('')
    const [cart,setcart] = useState('')
    const [codeMeli,setcodeMeli] = useState('')
    const [cartNumbrr,setcartNumbrr] = useState('')
    const [shebaNumber,setshebaNumber] = useState('')
    const [meliUrl,setmeliUrl] = useState('')
    const [profileUrl,setprofileUrl] = useState('')
    const [cartUrl,setcartUrl] = useState('')
    const [name,setname] = useState('')
    const [token,settoken] = useState('')
    const [error,seterror] =useState({codeMeli:'', cartNumbrr:'',shebaNumber:'',flag:true})
    const [flag,setflag] = useState(true)
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const isSmall = useMediaQuery('(max-width: 768px)')
    const[isLoading,setIsLoading] = useState(false)
    
    const [activeTab, setActiveTab] = useState('selfie');
  
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };


    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 1200, 1200, 'JPEG', 100, 0,
        uri => {
          resolve(uri);
        }, 'file' );
        });
    



















   async function handleChange(event) {


    if((event.target.name == 'profile' || event.target.name == 'meli' || event.target.name == 'cart') && event.target.files[0] ) {



                        let file =  event.target.files[0]
                        if (file.size > 10240000){
                            toast.dismiss()
                            toast.error("حداکثر سایز فایل انتخابی  ده مگابایت است ")
                            return
                        }
                        }




     if(event.target.name == 'meli' && event.target.files[0]) {

         setmeliUrl(URL.createObjectURL(event.target.files[0]));
         const imageMeli = await resizeFile(event.target.files[0]);

         setmeli(imageMeli)


     }else if(event.target.name == 'profile' && event.target.files[0]){
                  setprofileUrl(URL.createObjectURL(event.target.files[0]));
                  const image = await resizeFile(event.target.files[0]);

                  setprofile(image)


     }else if (event.target.name == 'cart' && event.target.files[0]){
                  setcartUrl(URL.createObjectURL(event.target.files[0]));
                  const imageCart = await resizeFile(event.target.files[0]);

                           setcart(imageCart)


     }else if(event.target.name == 'codeMeli'){
         let targetvalue = event.target.value
         if(IsDigit.test(targetvalue)){
             if(targetvalue.length==10){
                    seterror({...error ,codeMeli:''})
                     setcodeMeli(targetvalue)
                        setflag(false)
             }
             else {
                     seterror({...error ,codeMeli:'کد ملی خود را به درستی وارد نمایید'})
                        setflag(true)


             }
         }else{
                    seterror({...error ,codeMeli:'کد ملی خود را به درستی وارد نمایید'})
                        setflag(true)

         }
     }else if(event.target.name == 'cartNumber'){
         let targetvalue = event.target.value
         if(IsDigit.test(targetvalue)){
             if(targetvalue.length==16){
                    seterror({...error,cartNumbrr:''})
                    setcartNumbrr(targetvalue)
                        setflag(false)
             }else {
                 seterror({...error,cartNumbrr:'شماره کارت خود را به درستی وارد نمایید'})
                        setflag(true)

             }
         }else{
                     seterror({...error,cartNumbrr:'شماره کارت خود را به درستی وارد نمایید'})
                        setflag(true)
         }
     }else if(event.target.name == 'shebaNumber'){
         let targetvalue = event.target.value
         targetvalue = `IR${targetvalue}`
         console.log(targetvalue)

         if(IsSheba.test(targetvalue) && targetvalue.length == 26){
             seterror({...error,shebaNumber:''})
             setshebaNumber(targetvalue)
             setflag(false)


         }else {
             seterror({...error,shebaNumber:'شماره شبا خود را به درستی وارد نمایید'})
             setflag(false)

         }
     }

  }

  function handelexample() {
      setIsOpen(true)
  }




 async function handelSubmit(event){
        event.preventDefault()
        if(!profile)
        {
            toast.dismiss()
            toast.error('لطفا اطلاعات خود را کامل وارد نمایید')
            return
        }







        

        setIsLoading(true)
        const  formdata = new FormData();
        

       
        formdata.append('profile',profile)
     







        await axios.post('https://api.sinatether.com/Auth/request_complete_authentication/',formdata,{withCredentials:true}
        
        ).then((response) =>{
            console.log(response)
            if (response.status == 200){

                if (response.data['status'] == 200)

                toast.success('اطلاعات به درستی ارسال شد')

                setIsLoading(false)

                navigate('/Ehrazwaiting')

            }else{
                toast.error(response.data['message'])

            }
        }

        ).catch(error =>{
            if (error){

                toast.error('اطلاعات به درستی ارسال نشد دوباره امتحان کنید')
                setIsLoading(false)
    

            }
           
            }
        )
  }




        return(
            <MangeDashboard state={3}>


          <Toast type={type} message={message}/>
                <SelfiExample modalIsOpen={modalIsOpen} Openchanger={setIsOpen}/>



            <div className="jfsjhsdbsehraz  align-item-center top-auth2024">
                <div className="kjsjgfshfbs2345267462834">
                    <div className={''}>


                    <div className="tabs">
      <div className="tab-buttons">
        <button
          className={`tab-button ${activeTab === 'selfie' ? 'active' : ''}`}
          onClick={() => handleTabClick('selfie')}
        >
          احراز هویت سلفی
        </button>
        <button
          className={`tab-button ${activeTab === 'video' ? 'active' : ''}`}
          onClick={() => handleTabClick('video')}
        >
          احراز هویت با ویدیو
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'selfie' && 










<form>



 <div className="khsfsfiewrwr24242">
 <img   src="./images/shield.svg" className="sjfhsjgfnkrwejtimg pb-3" alt=""/>


                                            <div className="title-first-leve">
                                                احراز هویت سطح دو
                                            </div>

                                            <div className="d-flex-divee2424245">

                                                <div className="confsje353535242">
                                                    امکانات:
                                                </div>

                                                <div className="sub-ewrjbwr243524232 ">
                                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                                <div className="confsje353535242">
                                                    تمامی فرایند های اعم از خرید، فروش ، واریز و برداشت بدون محدودیت
                                                </div>
                                                </div>



                                               


                                                


                                                
                                                
                                            </div>


                                            <div className="disjfsf567894242" >
                                                    تصویر سلفی همراه با متن تعهدنامه ، مشابه تصویر نمونه باید ارسال شود.
                                                </div>

                                        </div>
<div className="row pt-2">



      <div className={'col-md-6'}>




        

  






  


          <div className="form-group">
              <img src={'images/selfiexample.png'} className="w-25 h-25  rounded mt-2 ml-2 mb-2" alt={'عکس خود'}/>
              <button type={'button'}  className={'btn bttexx btnsm ml-2'}  onClick={handelexample} >متن تعهدنامه</button>

    <div className="file-upload-wrapper" data-text="آپلود عکس سلفی">
       <input type={'file'} name={'profile'} className={'form-control'}     onChange={handleChange} required />
    </div>
              <h6 className="float-right mt-1 text-medium text-warning pl-2 muted24245335"> حداکثر اندازه 10مگابایت است</h6>

              {isSmall ?


                  <div className={'text-left'}>

                      {profileUrl ?
                          <img data-display-toggle={profileUrl} src={profileUrl}
                               className="imgfield  rounded mt-2 ml-2" alt={''}
                               onError={"this.style.display='none'"}/> :
                          <img src={""}/>}
                  </div>

                  :
                  <></>

              }



        </div>



   </div>

   <div className={'col-md-6'}>
   {isSmall ? <></>

:
<div className={'form-group'}>
      <div className={'text-right'}>

          {profileUrl ?
              <img data-display-toggle={profileUrl} src={profileUrl}
                   className="imgfield  rounded mt-2 ml-2" alt={''}
                   onError={"this.style.display='none'"}/> :
              <img src={""}/>}
      </div>

</div>
}

   </div>







</div>

<div className="align-items-center text-center pb-2">
    
    <button  type="submit" className=" btn-sehraz pl-5 pr-5" onClick={handelSubmit}>
        
        {isLoading ? 
            <i className="fa fa-spinner fa-spin"></i>
            :

         <span>ارسال</span>
        }
        
        
        </button>
</div>


</form>
        
        
        
        
        
        
        
        
        
        }
        {activeTab === 'video' &&






<form>



<div className="khsfsfiewrwr24242">
<img src="./images/shield.svg" className="sjfhsjgfnkrwejtimg pb-3" alt=""/>


                                           <div className="title-first-leve">
                                               احراز هویت سطح دو
                                           </div>

                                           <div className="d-flex-divee2424245">

                                               <div className="confsje353535242">
                                                   امکانات:
                                               </div>

                                               <div className="sub-ewrjbwr243524232 ">
                                               <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                               <div className="confsje353535242">
                                                   تمامی فرایند های اعم از خرید، فروش ، واریز و برداشت بدون محدودیت
                                               </div>
                                               </div>


                                               


                                               
                                               
                                           </div>

                                       </div>
<div className="row pt-2">



     <div className={'col-md-6 text-center'}>



        <div className="kfhsffghujiklhg764242">
            بزودی ...
        </div>

 







  </div>







</div>

<div className="align-items-center text-center pb-2">
   
   <button disabled={flag} type="submit" className="btn btn-sehraz pl-5 pr-5" onClick={handelSubmit}>
       
       {isLoading ? 
           <i className="fa fa-spinner fa-spin"></i>
           :

        <span>ارسال</span>
       }
       
       
       </button>
</div>


</form>         
         
         
         
         
         
         
         
         }
      </div>
    </div>




                    </div>





                    </div>

                </div>




            </MangeDashboard>





)

}
export default TopAuthentication;